// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TaTOR","selected":"styles_selected__3nW52"};